<div class="admin-container">
    <div>
        <ul class="tabs">
            <li *ngFor="let tab of tabs; let i=index"
                [class.active]="i===activeTabIndex"
                (click)="selectTab(i)">
                {{ tab }}
            </li>
        </ul>
    </div>
    <!-- Режим списка -->
    <div *ngIf="!editMode && activeTabIndex != 4">
        <div class="search-container">
            <input [(ngModel)]="searchQuery" placeholder="Поиск..." (keyup.enter)="search()">
            <button (click)="search()">Поиск</button>
            <button (click)="clearSearch()">Сбросить</button>
            <button (click)="openItem()">Добавить</button>
        </div>

        <div *ngIf="loading" class="loading-indicator">Загрузка данных...</div>

        <div *ngIf="!loading && currentData.length === 0" class="no-data">
            Нет данных для отображения
        </div>

        <table *ngIf="!loading && currentData.length > 0">
            <thead>
            <tr>
                <th>ID</th>
                <th>Порядковый номер</th>
                <th>Изображение</th>
                <th>Действия</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let item of currentData">
                <td>{{ item.id || '—' }}</td>
                <td>{{ item.orderNumber || '—' }}</td>
                <td *ngIf="item.images?.length > 0">
                    <img *ngFor="let img of item.images" [src]="getImageUrl(img)" [alt]="img">
                </td>
                <td *ngIf="item.image">
                    <img *ngIf="item.image" [src]="getImageUrl(item.image)" [alt]="item.image">
                </td>
                <td *ngIf="(!item.image && item.images?.length == 0) || item.image == ''">
                    <span>Нет изображений</span>
                </td>
                <td class="actions">
                    <button (click)="openItem(item)">Редактировать</button>
                    <button (click)="moveItem(item, 'up')">↑</button>
                    <button (click)="moveItem(item, 'down')">↓</button>
                    <button (click)="deleteItem(item)" class="delete">Удалить</button>
                </td>
            </tr>
            </tbody>
        </table>

        <div *ngIf="totalItems > 0" class="pagination">
            <button (click)="changePage(-1)" [disabled]="currentPage[activeTabIndex] === 1">
                Назад
            </button>
            <span>Страница {{ currentPage[activeTabIndex] }} из {{ Math.ceil(totalItems / pageSize) }}</span>
            <button (click)="changePage(1)"
                    [disabled]="currentPage[activeTabIndex] === Math.ceil(totalItems / pageSize)">
                Вперед
            </button>
        </div>
    </div>

    <div *ngIf="!editMode && activeTabIndex == 4" class="map-container">
        <app-old-map [edit]="true" (emitActiveEdit)="editPoint($event)" (emitNewEdit)="addPoint($event)"/>
        <div *ngIf="editMap" class="edit-window">
            <div class="edit-window-cross" (click)="closeMapEdit()">
                <app-icon [icon]="Icons.cross"/>
            </div>
            <div class="edit-form">
                <div class="tab-specific-form">
                    <div class="form-group">
                        <label>Статья</label>
                        <app-autocomplete-input
                                [options]="articles"
                                [searchTerm]="articleTitle"
                                [key]="'subTitle'"
                                (emitItem)="emitArticle($event)"
                        />
                    </div>
                    <div class="form-group">
                        <label>Событие</label>
                        <app-autocomplete-input
                                [options]="eventTypes"
                                [searchTerm]="mapPointsTitle"
                                [key]="'title'"
                                (emitItem)="emitMapPointsType($event)"
                        />
                    </div>
                    <p *ngIf="errorMapPoint" style="color: darkred;">Заполните обязательные поля</p>
                </div>
                <div class="form-actions">
                    <button class="form-actions-success" (click)="savePoint()">Сохранить</button>
                    <button *ngIf="!addPointFlag" class="form-actions-error" (click)="deletePoint()">Удалить</button>
                    <button class="form-actions-cancel" (click)="closeMapEdit()">Отмена</button>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="editMode" class="edit-form">
        <h2>{{ currentItem.id ? 'Редактирование' : 'Создание' }} {{ tabs[activeTabIndex] }}</h2>
        <div *ngIf="activeTabIndex === 0" class="tab-specific-form">
            <div class="form-group">
                <label>Порядковый номер</label>
                <input type="number" [(ngModel)]="currentItem.orderNumber" placeholder="Порядковый номер">
            </div>
            <div class="form-group">
                <label>Заголовок</label>
                <input type="text" [(ngModel)]="currentItem.title" placeholder="Заголовок">
            </div>
            <div class="form-group">
                <label>Подзаголовок</label>
                <input type="text" [(ngModel)]="currentItem.subTitle" placeholder="Подзаголовок">
            </div>
            <div class="form-group">
             <label>Текст</label>
            <textarea
                    id="message"
                    type="text"
                    inputmode="text"
                    placeholder="Текст"
                    [(ngModel)]="currentItem.text"
                    #messageTextarea
                    (input)="onInput(messageTextarea)">
            </textarea>
            </div>
            <label>Изображения<a (click)="setClearImages()">(удалить все изображения)</a></label>
            <div class="form-images">
                <div class="container-images">
                    <div *ngFor="let img of currentItem.images" class="form-images-image">
                        <img [src]="getImageUrl(img)" [alt]="img">
                    </div>
                    <div *ngFor="let file of files" class="form-images-image">
                        <img [src]="createObjUrl(file)" [alt]="file">
                    </div>
                    <div (click)="setImage()" class="form-images-image form-images-image-last">
                        +
                    </div>
                </div>
            </div>
            <p class="add-settings" (click)="additionalStyle = !additionalStyle">
                Дополнительные настройки<span *ngIf="additionalStyle">(скрыть)</span>
            </p>
            <div *ngIf="additionalStyle">
                <div class="form-group">
                    <label>Стили(size)</label>
                    <input type="text" [(ngModel)]="currentItem.size" placeholder="Стили(size)">
                </div>
                <div class="form-group">
                    <label>Стили(position)</label>
                    <input type="text" [(ngModel)]="currentItem.position" placeholder="Подзаголовок">
                </div>
                <div class="form-group">
                    <label>Стили(mobileSize)</label>
                    <input type="text" [(ngModel)]="currentItem.mobileSize" placeholder="Подзаголовок">
                </div>
                <div class="form-group">
                    <label>Стили(mobilePosition)</label>
                    <input type="text" [(ngModel)]="currentItem.mobilePosition" placeholder="Подзаголовок">
                </div>
            </div>
        </div>
        <div *ngIf="activeTabIndex === 1 || activeTabIndex === 3" class="tab-specific-form">
            <div class="form-group">
                <label>Порядковый номер</label>
                <input type="number" [(ngModel)]="currentItem.orderNumber" placeholder="Порядковый номер">
            </div>
            <div (click)="setImage()" class="form-images">
                <div *ngIf="files[0]" class="form-images-image form-images-image-last">
                    <img [src]="createObjUrl(files[0])" [alt]="currentItem.image">
                </div>
                <div *ngIf="currentItem.image && !files[0]" class="form-images-image form-images-image-last">
                    <img [src]="getImageUrl(currentItem.image)" [alt]="currentItem.image">
                </div>
                <div *ngIf="!currentItem.image && !files[0]" class="form-images-image form-images-image-last">
                    +
                </div>
            </div>
        </div>
        <div *ngIf="activeTabIndex === 2" class="tab-specific-form">
            <div class="form-group">
                <label>Порядковый номер</label>
                <input type="number" [(ngModel)]="currentItem.orderNumber" placeholder="Порядковый номер">
            </div>
            <div class="form-group">
                <label>Заголовок</label>
                <input type="text" [(ngModel)]="currentItem.title" placeholder="Заголовок">
            </div>
            <div class="form-group">
                <label>Подзаголовок</label>
                <input type="text" [(ngModel)]="currentItem.subTitle" placeholder="Подзаголовок">
            </div>
            <div class="form-group">
                <label>Текст</label>
                <textarea
                        id="message"
                        type="text"
                        inputmode="text"
                        placeholder="Текст"
                        [(ngModel)]="currentItem.text"
                        #messageTextarea
                        (input)="onInput(messageTextarea)">
            </textarea>
            </div>
            <div (click)="setImage()" class="form-images">
                <div *ngIf="files[0]" class="form-images-image form-images-image-last">
                    <img [src]="createObjUrl(files[0])" [alt]="currentItem.image">
                </div>
                <div *ngIf="currentItem.image && !files[0]" class="form-images-image form-images-image-last">
                    <img [src]="getImageUrl(currentItem.image)" [alt]="currentItem.image">
                </div>
                <div *ngIf="!currentItem.image && !files[0]" class="form-images-image form-images-image-last">
                    +
                </div>
            </div>
        </div>
        <div *ngIf="activeTabIndex === 4" class="tab-specific-form">

        </div>
        <div class="form-actions">
            <button class="form-actions-success" (click)="saveItem()">Сохранить</button>
            <button class="form-actions-cancel" (click)="cancelEdit()">Отмена</button>
        </div>
    </div>
</div>
<input #fileInput type="file" (change)="onFileChange()" accept="image/*" style="display: none;" />
